export const BASE_URL = '/api';
// export const BASE_URL = `${process.env.PUBLIC_URL}/api`;
export const ENDPOINTS = {
  AUTH: {
    // VERIFY_NUMBER: '/authenticate',
    VERIFY_NUMBER: '/otp',
    // VERIFY_CODE: '/authorize',
    VERIFY_CODE: '/login',
    REFRESH_TOKEN: '/refresh_token',
    LOGOUT: '/logout',
  },
  API: {
    callApi: '/call',
    bridgeApi: '/bridge',
    domainUserApi: '/domain_user',
    destinationApi: '/destination',
    feedApi: '/feed',
  }
};
